import React from "react";
import { styled } from "@mui/material";
import { Link } from "react-router-dom";
import { SyncStatusMessageType } from "../../../SyncProvider/types";
import { ParentRetailerSyncSession } from "../../../../types/misc";
import { SolidButton } from "../../../StoreComponents/StoreButton";
import { RetailerList } from "./index";

export const SyncButton = styled(SolidButton)(({ theme }) => ({
  fontSize: 14,
  width: "100%",
  minWidth: 355,
  maxWidth: 355,
  margin: "20px 0 0 0",
  backgroundColor: "#fff",
  color: theme.palette.primary.main,
  "&:hover": {
    backgroundColor: "#fff",
    color: theme.palette.primary.main,
  },
}));

interface SyncActionButtonProps {
  syncStatus:
    | "connecting"
    | "syncing"
    | "checking_rewards"
    | "error"
    | "completed"
    | undefined;
  latestSyncBatchId?: string;
}

const SyncActionButton = ({
  syncStatus,
  latestSyncBatchId,
}: SyncActionButtonProps) => {
  switch (syncStatus) {
    case "connecting":
    case "syncing":
      return <SyncButton disabled>View rewards summary</SyncButton>;
    case "checking_rewards":
      return (
        <Link
          to={`/sync/summary/${latestSyncBatchId}`}
          style={{ textDecoration: "none", width: "100%", maxWidth: 345 }}
        >
          <SyncButton trackedAdditionalData={{ latestSyncBatchId, syncStatus }}>
            View rewards summary
          </SyncButton>
        </Link>
      );
    case "error":
      return (
        <Link
          to={`/dashboard/accounts`}
          style={{ textDecoration: "none", width: "100%", maxWidth: 345 }}
        >
          <SyncButton trackedAdditionalData={{ latestSyncBatchId, syncStatus }}>
            View account details
          </SyncButton>
        </Link>
      );
    default:
      return null;
  }
};

const getSyncStatusSubtitleWidth = (
  status: SyncStatusMessageType | undefined
) => {
  switch (status) {
    case "connecting":
      return 294;
    case "syncing":
    case "checking_rewards":
    case "completed":
      return 378;
    case "error":
      return 260;
    default:
      return 424;
  }
};

const StatusWrapper = styled("div")<{
  status: SyncStatusMessageType | undefined;
}>(({ status }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  ".subtitle": {
    maxWidth: getSyncStatusSubtitleWidth(status),
  },
}));

interface SyncStatusContentProps {
  status: SyncStatusMessageType | undefined;
  title?: string;
  message?: string;
  syncStatusByParentRetailer: ParentRetailerSyncSession[];
  latestSyncBatchId?: string;
}

export const SyncStatusContent: React.FC<SyncStatusContentProps> = ({
  status,
  title,
  message,
  syncStatusByParentRetailer,
  latestSyncBatchId,
}) => {
  return (
    <StatusWrapper status={status}>
      <div className="title">{title}</div>
      <div className="subtitle">{message}</div>
      <RetailerList syncStatusByParentRetailer={syncStatusByParentRetailer} />
      <SyncActionButton
        syncStatus={status}
        latestSyncBatchId={latestSyncBatchId}
      />
    </StatusWrapper>
  );
};

export default SyncStatusContent;
